import { render, staticRenderFns } from "./hand.vue?vue&type=template&id=3a976d5d&"
import script from "./hand.vue?vue&type=script&lang=js&"
export * from "./hand.vue?vue&type=script&lang=js&"
import style0 from "./hand.vue?vue&type=style&index=0&id=3a976d5d&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports